import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMarkupMeasureNonlinearDistance = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21 5.5C21 6.88071 19.8798 7.99994 18.4991 7.99994C17.1183 7.99994 16 6.88071 16 5.5C16 4.11929 17.1193 3 18.5 3C19.8807 3 21 4.11929 21 5.5Z",
			fill: "#C8C8C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 18.5C8 19.8807 6.88071 21 5.5 21C4.11929 21 3 19.8807 3 18.5C3 17.1193 4.11833 15.9999 5.49905 15.9999C6.87976 15.9999 8 17.1193 8 18.5Z",
			fill: "#C8C8C8"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M5.49905 15.9999C5.95868 12.8734 7.49953 11.9998 11.5 12.0001C15.5005 12.0003 17.7609 10.9652 18.4991 7.99994M5.49905 15.9999C4.11833 15.9999 3 17.1193 3 18.5C3 19.8807 4.11929 21 5.5 21C6.88071 21 8 19.8807 8 18.5C8 17.1193 6.87976 15.9999 5.49905 15.9999ZM18.4991 7.99994C19.8798 7.99994 21 6.88071 21 5.5C21 4.11929 19.8807 3 18.5 3C17.1193 3 16 4.11929 16 5.5C16 6.88071 17.1183 7.99994 18.4991 7.99994Z",
			stroke: "currentColor",
			strokeWidth: 2
		})
	]
});
export default SvgMarkupMeasureNonlinearDistance;
